var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoList = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7884FD6F-D058-446A-8266-8B42E3B50923") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25,7.5 L25,10 L11.25,10 L11.25,7.5 L25,7.5 Z M25,13.75 L25,16.25 L11.25,16.25 L11.25,13.75 L25,13.75 Z M25,20 L25,22.5 L11.25,22.5 L11.25,20 L25,20 Z M8.75,7.5 L8.75,10 L5,10 L5,7.5 L8.75,7.5 Z M8.75,13.75 L8.75,16.25 L5,16.25 L5,13.75 L8.75,13.75 Z M8.75,20 L8.75,22.5 L5,22.5 L5,20 L8.75,20 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile-team-overview-table-view",
    transform: "translate(-1535.000000, -555.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-Info",
    transform: "translate(100.000000, 471.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-skills"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_list",
    transform: "translate(1430.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#191919",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_list.2fb43c78b8f8f8913b4635960d31d08c.svg";